import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';

type T = AppStyledProps;

export const MainStyled = styled.div<T>`
  img {
    max-height: 70vh;
    width: 100%;
  }

  p {
    max-height: 70vh;
    width: 30vw;
    min-height: 50vh;
    word-wrap: break-word;
    overflow-y: auto;
  }

  ${({ theme }) =>
    theme.device.mobile &&
    `
    p {
      width: 50vw;
    }
  `}
`;
